import { createSelector } from "reselect";
import _ from "lodash";

const getSearchDataColegios = state => state.busquedas.searchDataColegios;
const getColegiosConEscuelas = state => state.escuelas.listaColegiosEscuelas;

const getColegiosDisponibles = createSelector(
  [getSearchDataColegios, getColegiosConEscuelas],
  (searchDataColegios, colegiosConEscuelas) =>
    _.differenceWith(
      searchDataColegios,
      colegiosConEscuelas,
      (sdc, cce) => sdc.childKey === cce.id
    )
);

export { getColegiosDisponibles };



// WEBPACK FOOTER //
// ./src/ducks/escuelas/selectors.js